import SBBT004CEU from './SBBT-004CEU.js';
import SBBT004CUS from './SBBT-004CUS.js';
import SBBT004C from './SBBT-004C.js';
import SBDS002A from './SBDS-002A.js';
import SBDI003E from './SBDI-003E.js';
import SBDW002C from './SBDW-002C.js';
import SNGWBT01 from './SNGW-BT01.js';
import SBBT002C from './SBBT-002C.js';
import SPCB04VENEU from './SPCB-04VENEU.js';
import SPCB03VENEU from './SPCB-03VENEU.js';
import SPCB02VENEU from './SPCB-02VENEU.js';
import SPCB01VENEU from './SPCB-01VENEU.js';
import SBWS90CM from './SBWS-90CM.js';
import SBRC005B from './SBRC-005B.js';
import SBBT102C from './SBBT-102C.js';
import SBBT102CEU from './SBBT-102CEU.js';
import SBHT103C from './SBHT-103C.js';
import SBHT203C from './SBHT-203C.js';
import SMSN0031ZL from './SMSN-0031ZL.js';
import SBBT104CUS from './SBBT-104CUS.js';
import SBBT104CEU from './SBBT-104CEU.js';
import SBDW103C from './SBDW-103C.js';
import SBDW203C from './SBDW-203C.js';
import SBMO103Z from './SBMO-103Z.js';
import SBDW302C from './SBDW-302C.js';
import SBMS001A from './SBMS-001A.js';
import SBRK002C from './SBRK-002C.js';

export const BLE = {
	'SBBT-004CEU': SBBT004CEU,
	'SBBT-004CUS': SBBT004CUS,
	'SBBT-004C': SBBT004C,
	'SBDS-002A': SBDS002A,
	'SBDI-003E': SBDI003E,
	'SBDW-002C': SBDW002C,
	'SNGW-BT01': SNGWBT01,
	'SBBT-002C': SBBT002C,
	'SPCB-04VENEU': SPCB04VENEU,
	'SPCB-03VENEU': SPCB03VENEU,
	'SPCB-02VENEU': SPCB02VENEU,
	'SPCB-01VENEU': SPCB01VENEU,
	'SBWS-90CM': SBWS90CM,
	'SBRC-005B': SBRC005B,
	'SBBT-102C': SBBT102C,
	'SBBT-102CEU': SBBT102CEU,
	'SBHT-103C': SBHT103C,
	'SBHT-203C': SBHT203C,
	'SMSN-0031ZL': SMSN0031ZL,
	'SBBT-104CUS': SBBT104CUS,
	'SBBT-104CEU': SBBT104CEU,
	'SBDW-103C': SBDW103C,
	'SBDW-203C': SBDW203C,
	'SBDW-302C': SBDW302C,
	'SBMO-103Z': SBMO103Z,
	'SBMS-001A': SBMS001A,
	'SBRK-002C': SBRK002C,
};
